import m from "mithril";

type InputType = "text" | "number" | "email" | "tel" | "password"  ;

interface InputAttrs {
    id?:string,
    name:string, 
    type?:InputType,
    required?:boolean,
    pattern?:string,
    initialValue?:string|null,
    value?:string|null,
    placeholder?:string,
    readonly?:boolean,
    maxlength?:number,
    inputmode?: InputType,
    customValidity?:string,
    onFocus?:(str: string) => void,
    onValueChange: (newValue:string) => void,
}

interface LabelAttrs {
    label:string,
    required?:boolean,
    optional?:boolean,
    for?:string,
}

interface InputGroupAttrs extends InputAttrs, LabelAttrs {
    instruction?:string,
}

export interface Option {
    label: string;
    value: string;
}

interface RadioGroupAttrs extends LabelAttrs {
    name: string,
    options: Option[],
    onValueChange: (newValue:string) => void
}

interface SelectGroupAttrs extends LabelAttrs {
    name: string,
    value: string | null,
    options: Option[],
    hasEmptyOption: boolean,
    onValueChange: (newValue:string) => void
}

export function Label(): m.Component<LabelAttrs>{
    return {
        view(vnode) {
            return m("label.d-flex.flex-row.justify-content-between", {
                for: vnode.attrs.for,
            }, [
                
               m('div', [
                   m("small", vnode.attrs.label),
                    (vnode.attrs.required)? m('sup.ml-1', {class:"text-danger"}, '*'):null
               ]),
               
               (vnode.attrs.optional)? 
               m('div', [
                    
                    m('small', {class:"ml-auto text-muted"}, 'optional')
                    
                ]):null,
                
            ])
        }
    }
}

export function InputGroup(): m.Component<InputGroupAttrs> {
    return {
        oncreate(vnode) {            
            let fieldElem = vnode.dom.querySelector("input");
            if(fieldElem) {
                if(vnode.attrs.initialValue) {
                    fieldElem.setAttribute('value', vnode.attrs.initialValue);
                }                
            }
            
        },
        view(vnode) {
            let inputId = vnode.attrs.id || "input-id-" + vnode.attrs.name;
            let inputType = vnode.attrs.type || "text";
            let isRequired = vnode.attrs.required || false;
            let pattern = vnode.attrs.pattern || null;
            let inputValue = vnode.attrs.value || null;
            let placeholder = vnode.attrs.placeholder ||null;
            let name = vnode.attrs.name;
            return m("div.form-group", 
                [
                    m(Label, {
                        label: vnode.attrs.label,
                        required: isRequired,
                        optional: vnode.attrs.optional,
                        for:inputId
                    }),

                    m("input", {
                        id: inputId,
                        name: name,
                        value: inputValue,
                        type: inputType,
                        class: "form-control",
                        required: isRequired,
                        pattern: pattern,
                        placeholder: placeholder,
                        maxlength: vnode.attrs.maxlength,
                        inputmode: vnode.attrs.inputmode,
                        onfocus: (event) => {
                            inputValue = event.target.value;
                            var customScrollIdElem = document.getElementById('custom-scroll-id');
                            if(customScrollIdElem) {
                                document.body.style.overflow = "hidden";
                                customScrollIdElem.classList.add('custom-scroll');
                            }
                            
                            if(vnode.attrs.onFocus && inputValue) {                                
                                vnode.attrs.onFocus(inputValue);
                            }                            
                        },
                        onchange: (event) => {
                            console.log("new value : " + event.target.value);
                            inputValue = event.target.value;
                            if(inputValue) {
                                if(vnode.attrs.inputmode == 'number') {
                                    inputValue = inputValue.replace(/\D/g, "");
                                    event.target.value = inputValue;
                                }                                
                                vnode.attrs.onValueChange(inputValue);
                            } 
                        },              
                        oninvalid: (event) => {
                            //console.log("Invalid ", event);
                            //event.target.setCustomValidity('Hello')
                            if(event.target && vnode.attrs.customValidity) {
                                event.target.setCustomValidity(vnode.attrs.customValidity)
                            }
                        },
                    }), 

                    (vnode.attrs.instruction != null)?
                    m("small", {
                        class: "form-text text-muted"
                    }, vnode.attrs.instruction) : null
                ]            
            )
        }
    }
}

export function RadioGroup() : m.Component<RadioGroupAttrs> {
    return {
        view(vnode) {
            let isRequired = vnode.attrs.required || false;
            return m("div.form-group", [
                m(Label, {
                    label: vnode.attrs.label,
                    required: true
                }),

                m("div.form-check--", 
                    vnode.attrs.options.map(option =>
                        m("div", { class: "custom-control custom-control-inline custom-radio" }, [
                            m("input", {
                                name: vnode.attrs.name,
                                value: option.value,
                                type: "radio",
                                class: "custom-control-input pr-2",
                                id: option.value,
                                required: isRequired,
                                onclick: (event) => {   
                                    console.log(event.target.value);
                                    vnode.attrs.onValueChange(event.target.value);                                 
                                }
                            }),
                            m("label", { class: "custom-control-label", for: option.value }, 
                                option.label)
                        ])
                    )
                )
            ])
        }
    }
}

export function SelectionGroup() : m.Component<SelectGroupAttrs> {
    return {
        view(vnode) {
            let isRequired = vnode.attrs.required || false;
            return m("div.form-group", [
                m(Label, {
                    label: vnode.attrs.label,
                    required: isRequired
                }),

                m("select.form-control", {
                    name: vnode.attrs.name,
                    required: isRequired,
                    value: vnode.attrs.value || null,
                    onchange: (event) => {
                        // console.log("new value : " + event.target.value);
                        vnode.attrs.onValueChange(event.target.value);
                    },
                    onfocus: (event) => {
                        var customScrollIdElem = document.getElementById('custom-scroll-id');
                        if(customScrollIdElem) {
                            document.body.style.overflow = "auto";
                            customScrollIdElem.classList.remove('custom-scroll');
                        }
                    }
                },
                    [                                               
                        vnode.attrs.options.map(option =>
                            m("option", {
                                "value": option.value
                            }, option.label)
                        )
                    ]
                )
            ])
        }
    }
}


